import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';
import {
  REMOTE_CONFIG_DEFAULT,
  USE_LOCAL_CONFIG,
  MINIMUM_FETCH_INTERVAL_MS,
} from 'shared/constants';
import { firebaseInit } from './firebase.helper';

class RemoteConfigService {
  async init() {
    // Envs on local config (development/e2e) never read the fetched values —
    // getValue/getJsonValue short-circuit to REMOTE_CONFIG_DEFAULT below. Skip
    // Firebase entirely: the awaited fetchAndActivate is a live googleapis call
    // (SDK default timeout 60s) that otherwise blocks first render — the
    // dominant e2e cold-boot cost.
    if (USE_LOCAL_CONFIG) return;

    // TODO: move to central place
    const app = firebaseInit();

    this.remoteConfig = getRemoteConfig(app);

    this.remoteConfig.settings.minimumFetchIntervalMillis = MINIMUM_FETCH_INTERVAL_MS;

    this.remoteConfig.defaultConfig = REMOTE_CONFIG_DEFAULT;

    await this.fetchRemoteConfig();
  }

  async fetchRemoteConfig() {
    let fetchedRemotely;

    try {
      fetchedRemotely = await fetchAndActivate(this.remoteConfig);
    } catch (error) {
      console.error('[Remote Config] Unable to fetch remote config data', {
        message: error.message,
      });
    }

    if (!fetchedRemotely) {
      console.log(
        'No configs were fetched from the backend, and the local configs were already activated',
        fetchedRemotely,
      );
    } else {
      console.debug('Remote config has fetched');
    }
  }

  getValue(key) {
    if (USE_LOCAL_CONFIG) {
      console.info('[Remote Config] Using local config', { key });
      return REMOTE_CONFIG_DEFAULT[key];
    }

    return getValue(this.remoteConfig, key).asString();
  }

  getJsonValue(key) {
    if (USE_LOCAL_CONFIG) {
      console.info('[Remote Config] Using local config', { key });
      return REMOTE_CONFIG_DEFAULT[key];
    }

    try {
      return JSON.parse(getValue(this.remoteConfig, key).asString());
    } catch (e) {
      console.error('[Remote Config] Fail to parse value', {
        message: e.message,
      });
      return REMOTE_CONFIG_DEFAULT[key] || {};
    }
  }
}

export default new RemoteConfigService();
